import { Box, Stack } from "@mui/material";
import { IconCalendarSad } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import GameCard from "../cards/GameCard";
import DateChip from "../ui/DateChip";
import Text from "../ui/Text";

export const UpcomingGamesList = ({
  games,
  nextSevenDays,
  filledSevenDays,
}) => {
  const getNext7Days = () => {
    const result = [];
    const today = new Date();
    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setHours(0, 0, 0, 0);
      date.setDate(today.getDate() + i);
      // Filter games for this date (assuming game.datetime is a date string)
      const gamesForDay = games.filter((game) => {
        const gameDate = new Date(game.datetime);
        gameDate.setHours(0, 0, 0, 0);
        return gameDate.getTime() === date.getTime();
      });
      result.push({ date, games: gamesForDay });
    }
    return result;
  };

  let groups = [];
  if (nextSevenDays) {
    groups = getNext7Days();
  } else if (filledSevenDays) {
    groups = getNext7Days().filter((group) => group.games.length > 0);
  }

  return (
    <Stack spacing={3}>
      {groups.map(({ date, games }) => (
        <Box key={date}>
          <DateChip date={date} />
          <Stack spacing={2} sx={{ mt: 2 }}>
            {games.length > 0 ? (
              games.map((game) => (
                <Box
                  component={Link}
                  to={`/game-details/${game.id}`}
                  key={game.id}
                  sx={{ textDecoration: "none" }}
                >
                  <GameCard game={game} />
                </Box>
              ))
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <IconCalendarSad size={25} color="#999" />
                <Text
                  variant="paragraph3"
                  sx={{ color: "#999", textAlign: "center" }}
                >
                  No games scheduled
                </Text>
              </Box>
            )}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};
